export default "__VITE_ASSET__3tPeSIGd__";